import { Investment } from 'src/types';
import { getOrganizationDetails } from 'src/utils/functions/investmentServices';
import { colorsArray } from '../styles/global.style';
import { projectsTypeColorDict } from '../variables';
import { getEntityCategory } from './operatorServices';

//Holds all color categories
let allCategoriesColors = {};

//Return a dictionary with matching colors for each category (including custom)
//Updating the allCategoriesColors variable
//Example {development : '9C27B0'}
export function getCategoriesColors(investments: Investment[]) {
  if (Object.keys(allCategoriesColors).length > 0) return allCategoriesColors;

  //init index
  customColorIndex = -1;

  //Add new color for every new category (including custom)
  investments.forEach(investment => {
    const entity = getOrganizationDetails(investment);
    let category = getEntityCategory(entity).toLowerCase(); //all key in lower case
    category = category?.trim()?.toLowerCase() === 'custom' ? entity.customCategory : category;

    //Skip on exiting categories
    if (allCategoriesColors.hasOwnProperty(category)) return;

    //if category is found return the matching color otherwise set a custom color
    allCategoriesColors[category] = projectsTypeColorDict.hasOwnProperty(category)
      ? projectsTypeColorDict[category].color
      : getCustomColor();
  });

  return allCategoriesColors;
}

// Init the color index so the first item will be index 0
let customColorIndex = -1;
function getCustomColor() {
  //Index length check
  if (customColorIndex >= colorsArray.length) return '#9C27B0';

  //Advance the index pointer and return the color
  ++customColorIndex;
  return colorsArray[customColorIndex];
}
